import React, { Component } from 'react';
import { Row, Label, Col, Button, Card, CardBody, Input, Form, CardTitle } from 'reactstrap';
import logo from "../imgs/KLLogo2.png";
import MensajeModal from "../components/MensajeModal"
import TabAyudaAgente from "../components/TabAyudaAgente"
import { connect } from 'react-redux';
import { logout } from '../actions/index';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {
    return { agente: state.agente };
};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ logout }, dispatch)
    };
};


class HeaderComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            activeTab: '1',
            estadoModulo: "Activo",
            suspenderBase: {
                idSuspensionBase: "",
                tiempoSuspensionBase: "",
            },
        };
        this.toggleTab = this.toggleTab.bind(this);
        this.toggle = this.toggle.bind(this);
        this.modalAyuda = this.modalAyuda.bind(this);
        this.cerrarSesion = this.cerrarSesion.bind(this);
    }

    async cerrarSesion() {
        this.props.logout();
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    modalAyuda() {
        this.setState({
            modalTitulo: "Ayuda",
            modalMensaje:
                <div>
                    <p>Esta es la página para los Agentes que atenderán los servicios solicitados por los usuarios del Sistema de Gestión de Turnos.</p>
                    <p>Selecciona una opción de ayuda:</p>
                    <p></p>
                    <Card body>
                        <TabAyudaAgente></TabAyudaAgente>
                    </Card>

                    <p></p>
                    <p>Si no encuentras la ayuda que buscabas, tienes problemaso alguna queja, comunicate al:</p>
                    <p>(+57-1) 347 2311 ext. 186 (Departamento de TI)</p>
                </div>,
            modalFooter: <Button onClick={this.toggle}> Cerrar</Button>
        })
        this.toggle();
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    render() {
        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <Row>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <br />
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col xl={{ size: 2 }} lg={{ size: 3 }} md={{ size: 3 }} sm={{ size: 12 }}>
                                        <center>
                                            <Row>
                                                <Col xs={{ size: 12 }}>
                                                    <img style={{ verticalAlign: "middle" }} height="100%" src={logo} alt="logo" />
                                                </Col>
                                                <Col xs={{ size: 12 }}>
                                                    <CardTitle style={{ marginBottom: "0px" }}>Sistema de gestión de turnos</CardTitle>
                                                </Col>
                                            </Row>
                                        </center>
                                    </Col>
                                    <Col xl={{ size: 9 }} lg={{ size: 7 }} md={{ size: 7 }} sm={{ size: 12 }}>
                                        <center>
                                            <Label style={{ marginTop: "22px" }} for="estadoModuloLabel">Bienvenido administrador del Sistema.</Label>
                                        </center>
                                        <Form inline>
                                            <Col md={{ size: 6 }} xs={{ size: 12 }}>
                                                <Input style={{ width: "100%" }} type="email" name="email" id="exampleEmail" disabled={true} value={this.props.agente.nombreAgente + " " + this.props.agente.apellidoAgente} />
                                            </Col>
                                            <Col md={{ size: 6 }} xs={{ size: 12 }}>
                                                <Input style={{ width: "100%" }} type="email" name="email" id="exampleEmail" disabled={true} value={this.props.agente.correoAgente} />
                                            </Col>
                                        </Form>
                                    </Col>
                                    <Col xl={{ size: 1 }} lg={{ size: 2 }} md={{ size: 2 }} sm={{ size: 12 }}>
                                        <center>
                                            <p />
                                            <Button color="info" onClick={this.modalAyuda}>Ayuda</Button>
                                            <br />
                                            <Button color="danger" onClick={this.cerrarSesion} style={{ marginTop: "5px" }}>Logout</Button>
                                        </center>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <br />
            </div>
        );
    }


}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComp);
